import React, { Component } from "react"
import Icon from "react-icons-kit"
import { Segment, Label, Button } from "semantic-ui-react"
import "./CarouselLanding.css"
import PourquoiNous from "./PourquoiNous"
import Fonctions from "./Fonctions"
import CalculsPro from "./CalculsPro"
import Offre from "./Offre"
import Temoignage from "./Temoignage"
import QuestionSuggestion from "./QuestionSuggestion"

class CarouselLanding extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <form id="blocCarousel">
        <input type="radio" name="fancy" autofocus value="clubs" id="clubs" />
        <input type="radio" name="fancy" value="hearts" id="hearts" />
        <input type="radio" name="fancy" value="spades" id="spades" />
        <input type="radio" name="fancy" value="diamonds" id="diamonds" />
        <label for="clubs" id="FondCarousel">
          <Label id="test">
            Le meilleur compagnon
            <br />
            <br /> des artisans !
          </Label>
          <Button disabled id="btn14jours">
            {" "}
            14 jours d'essai gratuit
          </Button>
          <Button disabled id="btnDécouverte">
            {" "}
            Découvrez nos fonctionnalités
          </Button>
        </label>
        <label for="hearts" id="FondCarousel" />
        <label for="spades" id="FondCarousel" />
        <label for="diamonds" id="FondCarousel" />
        <PourquoiNous />
        <Fonctions />
        <CalculsPro />
        <Offre />
        <Temoignage />
        <QuestionSuggestion />
      </form>
    )
  }
}

export default CarouselLanding



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/CarouselLanding.js